import { encrypt, decrypt } from './crypto';

const store = {
  set: (
    keyObject: Record<string, unknown> | string,
    value?: string | undefined,
  ) => {
    if (typeof keyObject === 'object') {
      Object.keys(keyObject).forEach(function (key) {
        const encryptedValue = encrypt(keyObject[key] as string | undefined);

        localStorage.setItem(key, encryptedValue);
      });
    } else {
      const encryptedValue = encrypt(value);

      localStorage.setItem(keyObject, encryptedValue);
    }
  },

  get: (key: string) => decrypt(localStorage.getItem(key) || ''),

  clearAllLocalItem: () => localStorage.clear(),
};

export default store;
